'use client';

import Link from 'next/link';

interface ProductCardProps {
    product: {
        id: number;
        name: string;
        price: number;
        description?: string;
        category?: string;
        stock?: number;
        image?: string;
    };
    showDescription?: boolean;
    className?: string;
}

export function ProductCard({ product, showDescription = true, className = '' }: ProductCardProps) {
    return (
        <Link
            href={`/products/${product.id}`}
            className={`card card-glow group ${className}`}
        >
            <div className="aspect-square rounded-xl bg-neutral-900 flex items-center justify-center text-6xl mb-4 group-hover:scale-105 transition-transform">
                {product.image || '📦'}
            </div>

            {product.category && (
                <span className="badge-primary mb-2 inline-block text-xs">
                    {product.category}
                </span>
            )}

            <h3 className="font-semibold text-white group-hover:text-orange-400 transition-colors">
                {product.name}
            </h3>

            {showDescription && product.description && (
                <p className="text-sm text-neutral-500 mt-2 line-clamp-2">
                    {product.description}
                </p>
            )}

            <div className="flex justify-between items-center mt-4">
                <span className="text-2xl font-bold text-gradient-primary">
                    ${product.price}
                </span>
                {product.stock !== undefined && (
                    <span className="text-sm text-neutral-500">
                        Stock: {product.stock}
                    </span>
                )}
            </div>
        </Link>
    );
}

